module.exports = __webpack_public_path__ + "img/general_contractor.a1ecd889.jpg";